export const sideTrim = string => {
  const sideTrimed = string.replace(/(^\s*)|(\s*$)/g, "") ;

  return sideTrimed
};
export const entireTrim = string => {
  const entireTrimed = string.replace(/(\s*)/g, "") ;
  return entireTrimed
};